
















import { Component, Vue, Watch } from 'vue-property-decorator'
import 'normalize.css'
import Alert from '@/app/components/Common/Alert.vue'

@Component({
  head: {
    meta: [{
      name: 'spws:version',
      content: process.env.VUE_APP_VERSION
    }]
  },
  components: {
    Alert
  }
})

export default class App extends Vue {
  @Watch('$route')
  changeRoute (newRoute: any) {
    this.$root.$bvToast.hide('toast')
    if (newRoute.path !== '/error-page' && newRoute.path !== '/sp/error-page') {
      this.$store.commit('routeState/setRoute', newRoute.path)
    }
    // 完了アラート表示
    if (this.$store.state.alertState.alertFlag) {
      Vue.prototype.$alert.toast(this.$store.state.alertState.message)
      this.$store.commit('alertState/setAlertFlag', false)
    }
  }

  mounted () {
    const alert:any = this.$refs.alert
    Vue.prototype.$alert = alert

    window.addEventListener('DOMContentLoaded', function () {
      window.addEventListener('scroll', function () {
        let el: any = document.getElementById('b-toaster-top-right')
        if (el !== undefined && el !== null) {
          if (window.scrollY > 50) {
            el.classList.add('positionTop0')
            el.classList.remove('positionTop50')
          } else {
            el.classList.remove('positionTop0')
            el.classList.add('positionTop50')
          }
        }
      })
    })
  }
}
